export default function URLText(inputText: string) {
  let replacedText;

  replacedText = inputText.replace(/\n/gi, '\n ');

  const http_pattern =
    /(?<!\]\()(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])(?!\()/gim;

  replacedText = replacedText.replace(http_pattern, '[$1]($1)');

  const www_pattern = /(^|\s)(www\.[^\s]+)/gim;
  replacedText = replacedText.replace(www_pattern, '[$2](http://$2)');

  return replacedText;
}

export function URLTextHTML(inputText: string) {
  let replacedText;

  replacedText = inputText.replace(/\n/gi, '<br>');

  const http_pattern =
    /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
  replacedText = replacedText.replace(
    http_pattern,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
  );

  const www_pattern = /(^|[^/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(
    www_pattern,
    '$1<a href="http://$2" target="_blank" rel="noopener noreferrer">$2</a>'
  );

  return replacedText;
}
